
export function parseWiki(ins){
        let ous = ins;
        // remove all <, > and &
        ous = ous.replace(new RegExp("&", 'g'), "&amp;");
        ous = ous.replace(new RegExp("<", 'g'), "&lt;");
        ous = ous.replace(new RegExp(">", 'g'), "&gt;");
        
        // remove not printable
        ous = ous.replace(new RegExp("{np}([^]*?){/np}", 'g'), "");
        // process the pf (pre-formatted)
        ous = ous.replace(new RegExp("{pf}([^]*?){/pf}", 'g'), "<pre>$1</pre>");
        // ous = ous.replace(new RegExp("<pre>([^]*?){([^]*?)</pre>", 'g'), "<pre>$1__AO__$2</pre>"); // désactivé: je ne sais plus à quoi ça sert
        // ous = ous.replace(new RegExp("<pre>([^]*?)}([^]*?)</pre>", 'g'), "<pre>$1__AF__$2</pre>"); // et ça perturbe le tag suivant! :-s
        
        // [x] {br}              => <br />
        ous = ous.replace(new RegExp("{br}", 'g'), "<br />");
        // [x] {hr}              => <hr />
        ous = ous.replace(new RegExp("{hr}", 'g'), "<hr />");
        // [x] {sp}              => <span class="ry-filler"></span>
        ous = ous.replace(new RegExp("{sp}", 'g'), "<div style='display:inline-block; width:1em;'></div>");
        ous = ous.replace(new RegExp("{sp=([0-9]+?)}", 'g'), "<div style='display:inline-block; width:$1em;'></div>");
        
        // [x] {t1..6}{/t1..6}
        ous = ous.replace(new RegExp("{t1}([^]*?){/t1}", 'g'), "<div class='text-h3'>$1</div>");
        ous = ous.replace(new RegExp("{t2}([^]*?){/t2}", 'g'), "<div class='text-h4'>$1</div>");
        ous = ous.replace(new RegExp("{t3}([^]*?){/t3}", 'g'), "<div class='text-h5'>$1</div>");
        ous = ous.replace(new RegExp("{t4}([^]*?){/t4}", 'g'), "<div class='text-h6'>$1</div>");
        ous = ous.replace(new RegExp("{t5}([^]*?){/t5}", 'g'), "<div class='text-subtitle1'>$1</div>");
        ous = ous.replace(new RegExp("{t6}([^]*?){/t6}", 'g'), "<div class='text-subtitle2'>$1</div>");
        // [ ] {hl}{/hl}         => hyperlink
        ous = ous.replace(new RegExp("{hl}([^]*?){/hl}", 'g'), "<a href='$1' target='_blank'>$1</a>");
        // [x] {cf=color}{/cf}   => couleur de police
        ous = ous.replace(new RegExp("{cf=([^]*?)}([^]*?){/cf}", 'g'), "<span style='color:$1;'>$2</span>");
        // [x] {cb=color}{/cb}   => couleur de fond
        ous = ous.replace(new RegExp("{cb=([^]*?)}([^]*?){/cb}", 'g'), "<span style='background-color:$1;'>$2</span>");
        // [x] {ul}(.*?){/ul}    => underline
        ous = ous.replace(new RegExp("{ul}([^]*?){/ul}", 'g'), "<span style='text-decoration:underline;'>$1</span>");
        // [x] {it}(.*?){/it}    => italics
        ous = ous.replace(new RegExp("{it}([^]*?){/it}", 'g'), "<span style='font-style:italic;'>$1</span>");
        // [x] {bo}(.*?){/bo}    => bold
        ous = ous.replace(new RegExp("{bo}([^]*?){/bo}", 'g'), "<span style='font-weight:bold;'>$1</span>");
        // [x] {so}{/so}         => paragraph
        ous = ous.replace(new RegExp("{so}([^]*?){/so}", 'g'), "<span class='noprint'>$1</span>");
        // [x] {pg}{/pg}         => paragraph
        ous = ous.replace(new RegExp("{pg}([^]*?){/pg}", 'g'), "<p>$1</p>");
        // [ ] {i|NBR}           => indent 
        
        // [x] {ry}...{/ry}      => rythme
        ous = ous.replace(new RegExp("{ry}([^]*?){/ry}", 'g'), "<my-rythme moderators='' :notes='\"$1\"'></my-rythme>");
        // ous = ous.replace(new RegExp("{ry}([^]*?){/ry}", 'g'), `<my-rythme moderators='' :notes='"` + $1.replace(new Regex("'", "g"), "\\'") + `"'></my-rythme>`);
        ous = ous.replace(new RegExp("{ry=(.*?)}([^]*?){/ry}", 'g'), "<my-rythme :moderators='\"$1\"' :notes='\"$2\"'></my-rythme>");

        // [x] {tb}              => start table
        ous = ous.replace(new RegExp("{tb}([^]*?){/tb}", 'g'), "<table>$1</table>");
        // [x] {tr}              => start line
        ous = ous.replace(new RegExp("{tr}([^]*?){/tr}", 'g'), "<tr>$1</tr>");
        // [x] {th}...{/th}      => table cell header
        ous = ous.replace(new RegExp("{th}([^]*?){/th}", 'g'), "<th>$1</th>");
        // [x] {tc}...{/tc}      => table cell
        ous = ous.replace(new RegExp("{tc}([^]*?){/tc}", 'g'), "<td>$1</td>");
        
        // keep this last line to highlight untracked tags!
        ous = ous.replace(new RegExp("{([^]*?)}", 'g'), "<span style='color:Red;'>{$1}</span>");

        // restore the accolades inside <pre> tags
        ous = ous.replace(new RegExp("<pre>([^]*?)__AO__([^]*?)</pre>", 'g'), "<pre>$1{$2</pre>");
        ous = ous.replace(new RegExp("<pre>([^]*?)__AF__([^]*?)</pre>", 'g'), "<pre>$1}$2</pre>");

        // console.log("ous", ous);
        return "<div>" + ous + "</div>";
    }
